
import {
  AlterationsTypeKeys,
  ISetIsAlterationsModalOpenAction,
} from '../types'

export function setIsAlterationsModalOpenAction(show: boolean): ISetIsAlterationsModalOpenAction  {
  return { type: AlterationsTypeKeys.SET_ALTERATIONS_MODAL_OPEN, payload: show }
}
